/* eslint-disable no-sequences */
import React, { useState, useEffect } from "react";
import "../Product/ProductList.css";
import { FaEdit, FaTrash } from "react-icons/fa";
import ProductListHeader from "./ProductListHeader";
import ProductHeader from "./ProductHeader/ProductHeader";
import axios from "axios";
import { Api } from "../../BackendApi/api";
import img from "../../Component/Header/logo.png";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import Spinner from "../../Component/Spinner/Spinner";
import EditProductOverlay from "../Product/EditProductOverlay/EditProductOverlay";
import DeletePopup from "../../Component/DeletePopup/DeletePopup";
import ConfirmPopup from "../../Component/ConfirmPopup/ConfirmPopup";
import { formatIndianDate } from "../../Component/IndFormatDate/formatIndianDate";
import { APP_VERSION } from "../Version Provider/VersionConfig";

const columnToApiMap = {
    productName: "ProductName",
    description: "Description",
    categoryName: "CategoryName",
    mrp: "ProductMRP",
    sellingPrice: "ProductSellingPrice",
    coins: "AllotCoins",
    companyName: "CompName",
    status: "Status",
    stock: "CurrentStock",
    createdBy: "CreatedByAdminName",
    lastUpdated: "LastUpdate",
};

const ProductList = () => {
    const [globalSearch, setGlobalSearch] = useState("");
    const [columnSearch, setColumnSearch] = useState({
        Sr: "",
        productName: "",
        description: "",
        categoryName: "",
        image: "",
        mrp: "",
        sellingPrice: "",
        companyName: "",
        coins: "",
        status: "Active",
        stock: "",
        createdBy: "",
        lastUpdated: "",
    });

    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [sortState, setSortState] = useState({
        column: "lastUpdated", // default sorted column
        order: "desc", // default order
    });

    const [showEditModal, setShowEditModal] = useState(false);
    const [editingProduct, setEditingProduct] = useState(null);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    //version control state
    const [versionCode] = useState(APP_VERSION);
    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "success",
    });

    const navigate = useNavigate();
    const limit = 10;

    const handleEditClick = (product) => {
        setEditingProduct(product);
        setShowEditModal(true);
    };

    const handleDeleteClick = (id) => {
        setSelectedId(id);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                navigate("/");
                return;
            }

            const productToUpdate = data.find(
                (row) => row.originalProduct._id === selectedId,
            )?.originalProduct;

            if (!productToUpdate) {
                setPopup({
                    show: true,
                    message: "Product not found",
                    type: "error",
                });
                return;
            }

            const res = await axios.post(
                Api.editProducts,
                {
                    _id: productToUpdate._id,
                    CategoryId: productToUpdate.CategoryId,
                    ProductName: productToUpdate.ProductName,
                    Description: productToUpdate.Description,
                    ProductMRP: productToUpdate.ProductMRP,
                    ProductSellingPrice: productToUpdate.ProductSellingPrice,
                    AllotCoins: productToUpdate.AllotCoins,
                    CurrentStock: productToUpdate.CurrentStock,
                    Status: "Deactive",
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            if (res.data.status === 1) {
                setData((prev) =>
                    prev.map((row) =>
                        row.originalProduct._id === selectedId
                            ? {
                                  ...row,
                                  status: false,
                                  originalProduct: {
                                      ...row.originalProduct,
                                      Status: "Deactive",
                                  },
                              }
                            : row,
                    ),
                );
                setPopup({
                    show: true,
                    message: "Product deactivated successfully!",
                    type: "success",
                });
                setShowDeleteModal(false);
                setSelectedId(null);
                setData([]);
                setPage(1);
                setHasMore(true);
                fetchProducts(1);
            } else {
                setPopup({
                    show: true,
                    message: "Failed to deactivate product. Please try again.",
                    type: "error",
                });
            }
        } catch (err) {
            console.error("Error deactivating product:", err);
            setPopup({
                show: true,
                message: "Something went wrong",
                type: "error",
            });
        } finally {
            setShowDeleteModal(false);
            setSelectedId(null);
        }
    };

    const fetchProducts = async (pageNum = 1) => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                navigate("/");
                return;
            }

            const startfrom = (pageNum - 1) * limit;

            const apiSortColumn =
                columnToApiMap[sortState.column] || "LastUpdate";
            const apiSortOrder = sortState.order === "asc" ? 1 : -1;
            const res = await axios.post(
                Api.getProducts,
                {
                    VersionCode: versionCode,
                    startfrom,
                    limit,
                    Status:
                        columnSearch.status === "Active"
                            ? "true"
                            : columnSearch.status === "Deactive"
                              ? "false"
                              : "",
                    CategoryId: "",
                    productName: columnSearch.productName || "",
                    description: columnSearch.description || "",
                    categoryName: columnSearch.categoryName || "",
                    mrp: columnSearch.mrp || "",
                    sellingPrice: columnSearch.sellingPrice || "",
                    coins: columnSearch.coins || "",
                    searchstring: globalSearch || "",
                    lastUpdateStartDate: columnSearch.startDate
                        ? formatIndianDate(new Date(columnSearch.startDate))
                        : "",
                    lastUpdateEndDate: columnSearch.endDate
                        ? formatIndianDate(new Date(columnSearch.endDate))
                        : "",
                    SortColumn: apiSortColumn,
                    SortOrder: apiSortOrder,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                },
            );
            if (
                res.data.status === 0 &&
                res.data.message &&
                res.data.message.toLowerCase().includes("version")
            ) {
                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {res.data.message}
                        </>
                    ),
                    type: "error",
                });
                return;
            }
            if (res.data.status === 1 && Array.isArray(res.data.data)) {
                const products = res.data.data.map((item, index) => ({
                    Sr: startfrom + index + 1,
                    productName: item.ProductName || "",
                    description: item.Description || "",
                    categoryName: item.CategoryName || "N/A",
                    image:
                        item.ProductImages && item.ProductImages.length > 0
                            ? `${Api.baseurl}/${item.ProductImages[0]}`
                            : img,
                    mrp: item.ProductMRP || 0,
                    sellingPrice: item.ProductSellingPrice || 0,
                    companyName: item.CompName || "N/A",
                    coins: item.AllotCoins != null ? item.AllotCoins : 0,
                    status: item.Status === "true",
                    stock: item.CurrentStock != null ? item.CurrentStock : 0,
                    createdBy: item.CreatedByAdminName || "Admin",
                    lastUpdated: item.LastUpdate
                        ? formatIndianDate(item.LastUpdate)
                        : "-",
                    originalProduct: item,
                }));

                setData((prev) =>
                    pageNum === 1 ? products : [...prev, ...products],
                );
                if (products.length < limit) setHasMore(false);
            } else {
                setHasMore(false);
                if (
                    res.data.status === 0 &&
                    ["Invalid AuthToken", "AuthToken is required"].includes(
                        res.data.message,
                    )
                ) {
                    localStorage.removeItem("authToken");
                    localStorage.removeItem("currentUser");
                    navigate("/");
                }
            }
        } catch (err) {
            console.error("Error fetching products:", err);
            setPopup({
                show: true,
                message:
                    err.response?.data?.message || "Failed to fetch products.",
                type: "error",
            });
            setHasMore(false);
        } finally {
            setLoading(false);
        }
    };

    const handleSortChange = (column, order) => {
        setSortState({ column, order });
        setData([]);
        setPage(1);
        setHasMore(true);
    };

    useEffect(() => {
        setLoading(true);

        setData([]);
        setPage(1);
        setHasMore(true);
        const handler = setTimeout(() => {
            fetchProducts(1).finally(() => {
                setLoading(false);
            });
        }, 300);
        return () => clearTimeout(handler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [globalSearch, columnSearch, sortState]);

    const fetchMoreData = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchProducts(nextPage);
    };
    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    return (
        <div className="product-table-container">
            <ProductHeader
                search={globalSearch}
                setSearch={setGlobalSearch}
                columnSearch={columnSearch}
                setColumnSearch={setColumnSearch}
                onRefresh={() => {
                    setSortState({ column: "lastUpdated", order: "desc" });
                    setData([]);
                    setPage(1);
                    setHasMore(true);
                }}
            />

            <div className="product-table-wrapper" id="scrollableDiv">
                <ProductListHeader
                    columnSearch={columnSearch}
                    setColumnSearch={setColumnSearch}
                    currentSortColumn={sortState.column}
                    currentSortOrder={sortState.order}
                    onSortChange={handleSortChange}
                />

                {loading && page === 1 ? (
                    <Spinner />
                ) : data.length > 0 ? (
                    <>
                        <InfiniteScroll
                            dataLength={data.length}
                            next={fetchMoreData}
                            hasMore={hasMore}
                            loader={<Spinner />}
                            scrollableTarget="scrollableDiv"
                            style={{ overflow: "visible" }}
                        >
                            {data.map(
                                (row, index) => (
                                    console.log(
                                        "Row Data:",
                                        row.image ? row.image : "No image",
                                    ),
                                    (
                                        <div
                                            className="product-table-row"
                                            key={index}
                                        >
                                            <div className="product-table-cell">
                                                {row.Sr}
                                            </div>
                                            <div className="product-table-cell action-cell">
                                                <div className="product-action-icons">
                                                    <button
                                                        className="edit"
                                                        onClick={() =>
                                                            handleEditClick(
                                                                row.originalProduct,
                                                            )
                                                        }
                                                    >
                                                        <FaEdit />
                                                    </button>
                                                    <button
                                                        className="delete"
                                                        onClick={() =>
                                                            handleDeleteClick(
                                                                row
                                                                    .originalProduct
                                                                    ._id,
                                                            )
                                                        }
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="product-table-cell">
                                                <img
                                                    src={row.image}
                                                    alt={row.productName}
                                                    className="product-img"
                                                />
                                            </div>
                                            <div className="product-table-cell">
                                                {row.productName}
                                            </div>
                                            <div className="product-table-cell">
                                                {row.description}
                                            </div>
                                            <div className="product-table-cell">
                                                {row.categoryName}
                                            </div>
                                            <div className="product-table-cell">
                                                {row.mrp}
                                            </div>
                                            <div className="product-table-cell">
                                                {row.sellingPrice}
                                            </div>
                                            <div className="product-table-cell">
                                                {row.companyName}
                                            </div>
                                            <div className="product-table-cell">
                                                {row.coins}
                                            </div>
                                            <div className="product-table-cell">
                                                <div
                                                    className={`status-badge-product ${
                                                        row.status ? "active" : "deactive"
                                                    }`}
                                                >
                                                    {row.status ? "Active" : "Deactive"}
                                                </div>
                                            </div>
                                            <div className="product-table-cell">
                                                {row.stock}
                                            </div>
                                            <div className="product-table-cell">
                                                {row.createdBy}
                                            </div>
                                            <div className="product-table-cell">
                                                {row.lastUpdated}
                                            </div>
                                        </div>
                                    )
                                ),
                            )}
                        </InfiniteScroll>

                        {!hasMore && (
                            <div className="no-data">
                                {loading
                                    ? "Searching products..."
                                    : "No more products "}
                            </div>
                        )}
                    </>
                ) : (
                    <div className="end-message"></div>
                )}
            </div>

            {showEditModal && editingProduct && (
                <EditProductOverlay
                    product={editingProduct}
                    onClose={() => setShowEditModal(false)}
                    onSave={() => {
                        setShowEditModal(false);
                        setData([]);
                        setPage(1);
                        setHasMore(true);
                        fetchProducts(1);
                    }}
                />
            )}

            <DeletePopup
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={confirmDelete}
            />
            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />
        </div>
    );
};

export default ProductList;
